export const COORDINATES_LANDSLIDE = 1;